import React from 'react';
import { type RestAccountData } from '@bbkAdminUtils/api-client/rest-modals-cards-types';
import { cs } from '@bbkAdminUtils/css-utils';
import CustomerHtml from '@bbkFunnelComponents/customer_html/customer_html';

type Props = {
  reasons: RestAccountData;
  reason: {
    label: string;
  };
};
const DataReasons: React.FC<Props> = (props) => {
  const { reasons, reason } = props;

  const reasonsOrganized = [];
  if (reasons.account) {
    reasonsOrganized.push({
      key: 'Account',
      value: reasons.account,
      classes: 'flex-shrink-0',
    });
  }
  reasonsOrganized.push({ key: 'Reason', value: reason.label });
  if (reasons.customer_since) {
    reasonsOrganized.push({
      key: 'Customer since',
      value: reasons.customer_since,
      classes: 'flex-shrink-0',
    });
  }

  return (
    <>
      {reasonsOrganized.map((r, idx) => {
        let classes = 'pr-md-3 pl-md-3';
        if (idx === 0) classes = 'pr-md-3';
        if (idx === reasonsOrganized.length - 1) classes = 'pl-md-3';
        return (
          <div
            className={cs('reason-wrapper pb-3 pb-md-0', classes, r.classes)}
            key={r.key}
          >
            <div className="reason">{r.key}</div>
            <div className="value">
              <CustomerHtml value={r.value} />
            </div>
          </div>
        );
      })}
    </>
  );
};

export default DataReasons;
